import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83253592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  class: "modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-title"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { id: "modal-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-subtitle" }, "Enter your name to join the session", -1))
const _hoisted_6 = { class: "modal-body" }

import { onMounted, ref } from 'vue';
import PFInput from "@/components/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: {}
  },
  emits: ['completed'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const name = ref('');
onMounted(() => {
  const input = document.getElementById('selectNameInput');
  if (input) {
    input.focus();
  }
})

function completed() {
  if (name.value && name.value.trim()) {
    emit('completed', name.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(PFInput, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          onCompleted: completed,
          "max-length": 25,
          placeholder: "Your name"
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})